import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';

import VariantFieldSet from 'bento-ordering/base/components/VariantFieldSet';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { StyledTypographyWithDisabled } from 'components/StyledTypographyWithDisabled';
import {
  getMenuItemNamesLightColor,
  getMenuItemNamesMediumColor
} from 'styles/helpers/getThemeStyles';

const GridContainer = styled(Grid)({
  display: 'flex'
});

const GridItem = styled(Grid)({
  flexGrow: 1,
  lineHeight: '42px',
  textAlign: 'right'
});

const StyledRadio = styled(Radio)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    fill: getMenuItemNamesLightColor(theme)
  },
  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      fill: getMenuItemNamesMediumColor(theme)
    }
  }
}));

function RadioButtonGroup({
  list,
  title,
  onChange,
  value,
  required,
  helperText,
  isSizeSection,
  hasInvestorDayFeature
}) {
  /**
   * returns `inputProps` for the Radio component
   */
  const getRadioInputProps = () => {
    const inputProps = {};
    if (required) {
      inputProps['aria-required'] = true;
    }
    return inputProps;
  };

  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <VariantFieldSet title={title} required={required} helperText={helperText}>
      <Grid container>
        <RadioGroup
          aria-label={title}
          name={title}
          value={value}
          onChange={onChange}
        >
          <Grid container>
            {list &&
              list.map((item, index) => {
                const { label, value, price } = item;
                return (
                  <GridContainer container key={index} style={{ zIndex: 0 }}>
                    <Grid item>
                      <FormControlLabel
                        value={value}
                        control={
                          <StyledRadio inputProps={getRadioInputProps()} />
                        }
                        label={
                          <StyledTypographyWithDisabled
                            {...styles}
                            isDisabled={!!item.disabled}
                          >
                            {label}
                          </StyledTypographyWithDisabled>
                        }
                        key={index}
                        disabled={!!item.disabled}
                      />
                    </Grid>
                    <GridItem item>
                      <StyledTypographyWithDisabled
                        component="span"
                        key={index}
                        {...styles}
                        isDisabled={!!item.disabled}
                      >
                        {!hasInvestorDayFeature && price
                          ? `${isSizeSection ? '' : '+'}$${price}`
                          : ' '}
                      </StyledTypographyWithDisabled>
                    </GridItem>
                  </GridContainer>
                );
              })}
          </Grid>
        </RadioGroup>
      </Grid>
    </VariantFieldSet>
  );
}

RadioButtonGroup.propTypes = {
  list: PropTypes.array.isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  required: PropTypes.bool,
  helperText: PropTypes.string,
  isSizeSection: PropTypes.bool.isRequired,
  hasInvestorDayFeature: PropTypes.bool.isRequired
};

export default RadioButtonGroup;
